import { render } from "./AddIncotermPage.vue?vue&type=template&id=545aa17e&ts=true"
import script from "./AddIncotermPage.vue?vue&type=script&lang=ts"
export * from "./AddIncotermPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__